
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-parlament-catalunya-2024/pactometre",
      function () {
        return require("private-next-pages/3catinfo/eleccions-parlament-catalunya-2024/pactometre/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-parlament-catalunya-2024/pactometre"])
      });
    }
  